import { Model } from 'json-api-models';

import { Models, Question, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';

export class TutorialSession extends Model<Schemas['tutorialSessions'], Models> {
    get startedAtDate() {
        return nullableDate(this.startedAt);
    }

    get updatedAtDate() {
        return nullableDate(this.updatedAt);
    }

    attemptFor(question?: Question) {
        return this.questionAttempts?.find((attempt) => attempt.question === question);
    }
}
